const { InnerBlocks } = wp.blockEditor;

const Save = ({ attributes }) => {
  const { variant, background, image, margin } = attributes;

  return (
    <section className={`locations ${background} ${variant} ${margin}`}>
      <div className="Container">
        {image && (
          <img
            className="locations-bg"
            src={image.src}
            alt={image.alt}
            width={image.width}
            height={image.height}
          />
        )}
        <InnerBlocks.Content />
      </div>
    </section>
  );
};

export default Save;
